import { Col, Form, ToggleButton, ToggleButtonGroup } from "react-bootstrap";

export default function MusicSelectionTypePicker({ formData, setFormData, name }) {
    return (
        <Form.Group as={Col} className="d-flex flex-column col-12 col-xl-auto">
            <Form.Label>Selection</Form.Label>
            <ToggleButtonGroup
                type="radio"
                name="result"
                className="ra-switcher"
                value={formData.selectionType}
                onChange={value => setFormData({ ...formData, selectionType: value })}>
                <ToggleButton className="text-nowrap" id={`${name}-results-new`} variant="ra-dark-blue-outline" value={"new"}>
                    New Songs
                </ToggleButton>
                <ToggleButton className="text-nowrap" id={`${name}-results-all`} variant="ra-dark-blue-outline" value={"all"}>
                    All Songs
                </ToggleButton>
                <ToggleButton className="text-nowrap" id={`${name}-results-top50`} variant="ra-dark-blue-outline" value={"top"}>
                    Top 50
                </ToggleButton>
            </ToggleButtonGroup>
        </Form.Group>
    );
}
